export default "__VITE_ASSET__WPZIQ3Gs__"